export default function resolveDependencies(dependencyResolver) {
  return [
    '$q',
    '$ocLazyLoad',
    ($q, $ocLazyLoad) => $q((resolve) => dependencyResolver((...dependencies) => resolve($ocLazyLoad.inject(dependencies)))),
  ];
}

export function resolveService(name, ...dependencies) {
  return ['$injector', ...dependencies, ($injector) => $injector.get(name)];
}



// WEBPACK FOOTER //
// ./src/routes/resolveDependencies.js